import React from 'react';
import { useIntl } from 'react-intl';
import { AuthoredEvidence, EmptyComponent, Evidence } from '@eas/common-web';
import { Fields } from './import-fields';
import { useColumns } from './import-columns';
import { useEvidencePermission } from '../../utils/permission-hook';
import { EvidenceApiUrl } from '@enums';

export function Imports() {
  const intl = useIntl();

  const permissions = useEvidencePermission({
    options: {
      NEW: [],
      EDIT: [],
      REMOVE: [],
      REFRESH: [],
      SHARE: [],
      CHECK: [],
      SAVE: [],
      CLOSE: [],
    },
  });

  const evidence = AuthoredEvidence.useAuthoredEvidence<any>({
    version: 1,
    identifier: 'IMPORTS',
    apiProps: {
      url: EvidenceApiUrl.IMPORTS,
    },
    tableProps: {
      columns: useColumns(),
      tableName: intl.formatMessage({
        id: 'TAPIS__IMPORTS__TABLE__TITLE',
        defaultMessage: 'Přehled importů do DZ',
      }),
      //reportTag: ExportTag.TICKETS_GRID,
    },
    detailProps: {
      GeneralFieldsComponent: EmptyComponent,
      FieldsComponent: Fields,
      toolbarProps: {
        title: intl.formatMessage({
          id: 'TAPIS__IMPORTS__DETAIL__TITLE',
          defaultMessage: 'Importy',
        }),
        showBtn: permissions,
      },
    },
  });

  return <Evidence {...evidence} />;
}
